import { action, observable } from 'mobx'

export class FAQService {
  @observable
  isOpen = false
  @observable
  isTermsOpen = false
  @observable
  isNewsLetterDialogOpen = false

  category: string = ''
  questions: string[] = []

  @action
  show(category: string, questions: string[]) {
    this.category = category
    this.questions = questions
    this.isOpen = true
  }

  @action
  close = () => {
    this.category = ''
    this.questions = []
    this.isOpen = false
  }

  @action
  showTerms = () => {
    this.isTermsOpen = true
  }

  @action
  closeTerms = () => {
    this.isTermsOpen = false
  }

  @action
  openNewsLetterDialog = () => {
    this.isNewsLetterDialogOpen = true
  }

  @action
  closeNewsLetterDialog = () => {
    this.isNewsLetterDialogOpen = false
  }
}
